import './CreateApiKeyForm.scss';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { FormEvent, ReactElement } from 'react';
import { ButtonWithLoader } from '../../../../design/buttons/ButtonWithLoader';
import { AddIcon } from '../../../../design/static/icons/AddIcon';
import { ValidatedTextInput } from '../../../components/ValidatedTextInput';
import { InputStatus } from '../../../models/error.model';

interface IProps {
  name: string;
  nameStatus: InputStatus;
  onNameChange: (email: string) => void;
  validateName: (email: string) => void;
  onAddNewApiKey: () => Promise<void>;
}

export const CreateApiKeyForm = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  const handleOnSubmit = (e: FormEvent): void => {
    e.preventDefault();
    void props.onAddNewApiKey();
  };

  return (
    <div className='create-api-key-form'>
      <div>
        <h4>{t('how_does_api_key_generator_work')}</h4>
        <div>{t('enter_your_api_key_name_and_press_add_button_new_key_will_be_generated_automatically')}</div>
      </div>
      <form
        className='add-api-key'
        onSubmit={handleOnSubmit}
      >
        <ValidatedTextInput
          id='new-api-key-input'
          className='new-api-key-input'
          labelText={''}
          value={props.name}
          onChange={props.onNameChange}
          onBlur={props.validateName}
          feedbacks={props.nameStatus.errorCodes}
          isValid={props.nameStatus.isValid}
          placeholder={t('api_key_name')}
        />
        <ButtonWithLoader
          id='add-api-key-button'
          loaderKey='add-api-key-button'
          color='primary'
          onClick={handleOnSubmit}
          disabled={props.nameStatus.isValid === false}
          startDecorator={<AddIcon />}
        >
          {t('add')}
        </ButtonWithLoader>
      </form>
    </div>
  );
});
